<template>
  <div id="app">
    <keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  @import "./assets/css/reset.css";
  @import "./assets/css/animate.min.css";
  @import "./assets/css/all.min.css";
  :root {
      --theme: #004897
  }
  #app{
      background: #F1F1F1;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue